// Everything here is resolved on use rather than captured in the constructor.
// renderContents() replaces the notification's own markup on every add-to-cart,
// and the header can be replaced outright by an A/B swap - a ref taken at
// upgrade time was pointing at a detached node in both cases. The close buttons
// are delegated on this element so they survive the same re-render.
class CartNotification extends HTMLElement {
  get notification() {
    return document.getElementById('cart-notification');
  }

  get header() {
    return document.querySelector('sticky-header');
  }

  connectedCallback() {
    // connectedCallback also fires on a plain move; these listeners live on the
    // element (or are removed on close), so bind them only once.
    if (this._bound) return;
    this._bound = true;

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    ThemeBind.delegate(this, 'click', 'button[type="button"]', () => this.close());
  }

  open() {
    const notification = this.notification;
    if (!notification) return;
    notification.setAttribute('data-active', '');

    notification.addEventListener(
      'transitionend',
      () => {
        notification.focus();
        trapFocus(notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    const notification = this.notification;
    if (notification) notification.removeAttribute('data-active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      // Resolved per section and null-guarded: a swapped-in layout may not carry
      // every target, and one missing id used to throw and abandon the rest.
      const target = document.getElementById(section.id);
      if (!target) return;
      target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const header = this.header;
    if (header && typeof header.reveal === 'function') header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
